import { Countries } from "./Country.model";

export var countries: Countries [] = [
    { code: "BE",  name: "Belgium"},
	{ code: "EL",  name: "Greece"},
    { code: "LT",  name: "Lithuania"},
    { code: "PT",  name: "Portugal"},
    { code: "BG",  name: "Bulgaria"},
    { code: "ES",  name: "Spain"},
    { code: "LU",  name: "Luxembourg"},
    { code: "RO",  name: "Romania"},
    { code: "DK",  name: "Denmark"},
    { code: "HR",  name: "Croatia"},
    { code: "MT",  name: "Malta"},
    { code: "SK",  name: "Slovakia"},
    { code: "DE",  name: "Germany"},
    { code: "IT",  name: "Italy"},
    { code: "NL",  name: "Netherlands"},
    { code: "FT",  name: "Finland"},
    { code: "EE",  name: "Estonia"},
    { code: "CY",  name: "Cyprus"},
    { code: "AT",  name: "Austria"},
	{ code: "SE",  name: "Sweden"},
    { code: "IE",  name: "Ireland"},
	{ code: "LV",  name: "Latvia"},
    { code: "PL",  name: "Poland"},
	{ code: "CZ",  name: "Czechia"},
    { code: "FR",  name: "France"},
    { code: "HU",  name: "Hungary"},
    { code: "SI",  name: "Slovenia"}
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/coutry-data-store.ts